import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const LeaveRoomIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} width="18" height="14" viewBox="0 0 18 14">
        <g fill="none" fillRule="evenodd">
            <path d="M21-5v24H-3V-5z" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M7 14v-4h6V4H7V0L0 7l7 7zM18 0h-2v14h2V0z"
            />
        </g>
    </SvgIcon>
);

export default LeaveRoomIcon;
